import React from "react";

/**
 * Full-page loading overlay.
 * Usage: if (loading) return <PageLoader message="Loading transactions…" />;
 */
export default function PageLoader({ message = "Loading…" }) {
  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999,
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      background: "#f8fafc",
      fontFamily: "'Inter', system-ui, sans-serif",
    }}>
      {/* Spinner */}
      <div style={{
        width: 52, height: 52, borderRadius: "50%",
        borderWidth: "4px",
        borderStyle: "solid",
        borderColor: "#e2e8f0",
        borderTopColor: "#7c3aed",
        animation: "pl-spin 0.75s linear infinite",
        marginBottom: 20,
      }} />

      {/* Message */}
      <p style={{
        margin: 0, fontSize: 14, fontWeight: 600,
        color: "#64748b", letterSpacing: "-0.1px",
      }}>
        {message}
      </p>

      <style>{`
        @keyframes pl-spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
